import React from 'react';
import './ViceChancellorMessage.css';

function ViceChancellorMessage() {
  return (
    <div className="vc-message">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 vc-content text-center">
            {/* Image at the top */}
            <img
              src={process.env.PUBLIC_URL + '/vcimage4.png'}
              alt="Vice Chancellor"
              className="vc-image mb-4"
            />

            {/* Message content below the image */}
            <div className="message-content">
              <h2 className="mb-4">Vice Chancellor's Message</h2>
              <p>
                It is with immense pride and pleasure that I extend my heartfelt greetings to all members of the Quaid-e-Awam University family; our students, faculty, alumni, and esteemed stakeholders. As a leading institution dedicated to engineering, science, and technology, we remain steadfast in our commitment to fostering innovation, excellence, and societal impact.
              </p>
              <p>
                Our mission is not just to impart knowledge but to inspire a lifelong passion for learning and innovation. At QUEST, we believe in equipping our students with the skills, vision, and resilience required to address the challenges of tomorrow. Our emphasis on academic excellence, research, and community engagement is shaping a new generation of leaders who will contribute meaningfully to the progress of our nation and the global community.
              </p>
              <p className="mt-4">
                With best regards,
              </p>
              <p>
                <strong>Prof. Dr. Saleem Raza Samo</strong><br />
                Vice Chancellor<br />
                Quaid-e-Awam University of Engineering, Science, and Technology
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ViceChancellorMessage;
